// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__19HGx","header":"ReportDetails_header__33fgx","title":"ReportDetails_title__KHzNV","left":"ReportDetails_left__1vdV9"};